// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dashboard-sketch-input--phlfu{max-width:800px;margin:0 auto;background:inherit}.dashboard-sketch-input__hint--vpNgI{font-size:.875rem;color:#96a0b4;font-weight:400;margin:0;text-align:center}.dashboard-sketch-input--with-hint--Hf1lh>[class*=chat-input__header]{margin-bottom:2px !important}.dashboard-sketch-input--phlfu textarea.base-input.multiline{height:calc(6em + 48px)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dashboard-sketch-input": "dashboard-sketch-input--phlfu",
	"dashboard-sketch-input__hint": "dashboard-sketch-input__hint--vpNgI",
	"dashboard-sketch-input--with-hint": "dashboard-sketch-input--with-hint--Hf1lh"
};
export default ___CSS_LOADER_EXPORT___;
